var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTierTopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2705_1150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 13.9998C13.2536 13.9998 13.9998 13.2536 13.9998 12.3332C13.9998 11.4127 13.2536 10.6665 12.3332 10.6665C11.4127 10.6665 10.6665 11.4127 10.6665 12.3332C10.6665 13.2536 11.4127 13.9998 12.3332 13.9998Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 13.9998C4.58714 13.9998 5.33333 13.2536 5.33333 12.3332C5.33333 11.4127 4.58714 10.6665 3.66667 10.6665C2.74619 10.6665 2 11.4127 2 12.3332C2 13.2536 2.74619 13.9998 3.66667 13.9998Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 5.3335H13.3332L15.3332 7.3335V10.6668H10.6665V5.3335Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 2H0.666504V10.6667H10.6665V2Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2705_1150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierTopIcon);
export default __webpack_public_path__ + "static/media/tier-top-Icon.9e508d70f3d9e2930adf8f1a6a513fb3.svg";
export { ForwardRef as ReactComponent };